import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { SESSION_STORAGE_KEYS } from '@chegg-wt/core/utils/sessionStorage'
import { safeJsonParser } from '../utils/safeJsonParser'
import { useRoutesContext } from '../components/RoutesContext'
import { NEW_PROJECT_ID } from '../constants/projects'
import { UserRoles } from '../constants/user'
import { defaultSourceType, sourceTypeById } from '../utils/sourceTypes'
import { initializedSelector } from '../state/app/selectors'
import {
  currentStyleSelector,
  currentProjectIdSelector,
  currentProjectSetInProgressSelector,
} from '../state/currentProject/selectors'
import useRedirect from './useRedirect'
import useUserRole from './useUserRole'

const useCiteFormRedirect = (rawCiteFormData: string, isPremiumFlow: boolean = false) => {
  const citation = safeJsonParser(rawCiteFormData) ?? {}
  const { toNewCitation, toCitationListForm } = useRoutesContext()
  const sourceType = sourceTypeById(citation?.source)?.id ?? defaultSourceType?.id
  const userRole = useUserRole()
  const initialized = useSelector(initializedSelector)
  const currentProjectSetInProgress = useSelector(currentProjectSetInProgressSelector)
  const currentStyle = useSelector(currentStyleSelector)
  const currentProjectId = useSelector(currentProjectIdSelector)

  useEffect(() => {
    sessionStorage.setItem(
      SESSION_STORAGE_KEYS.searchData,
      JSON.stringify({ data: citation })
    )
  }, [])

  useRedirect({
    shouldRedirect: initialized && !currentProjectSetInProgress,
    redirectRoute:
      isPremiumFlow && userRole === UserRoles.PRO_USER
        ? toCitationListForm({
            projectId: currentProjectId || NEW_PROJECT_ID,
            sourceType,
          })
        : toNewCitation({
            style: currentStyle || 'mla9',
            sourceType,
          }),
  })
}

export default useCiteFormRedirect
